<div class="error-banner" *ngIf="message" [class.warning]="type === 'warning'" [class.info]="type === 'info'">
  <mat-icon class="icon" *ngIf="type === 'error'">error_outline</mat-icon>
  <mat-icon class="icon" *ngIf="type === 'warning'">warning</mat-icon>
  <mat-icon class="icon" *ngIf="type === 'info'">info</mat-icon>
  <span>{{ message }}</span>
</div>
